"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OidcSessionStorage_1 = require("./OidcSessionStorage");
var OidcClient = /** @class */ (function () {
    function OidcClient(params, oAuthParams) {
        var _this = this;
        this.storage = new OidcSessionStorage_1.OidcSessionStorage();
        this.doLogin = function () {
            var state = "S" + Math.random() + Date.now();
            var nonce = "N" + Math.random() + Date.now();
            _this.storage.State.set(state);
            _this.storage.Nonce.set(nonce);
            var encodedRedirectUrl = encodeURIComponent(_this.params.redirectUrl);
            var baseUrl = location.protocol + "//" + location.host + "/" + _this.params.callbackUrl;
            var redirectUri = baseUrl + "?redirectUrl=" + encodedRedirectUrl + "&";
            var url = new URL(_this.oAuthParams.identityUrl + "/identity/connect/authorize");
            url.search = new URLSearchParams({
                nonce: nonce,
                state: state,
                acr_values: _this.oAuthParams.acrValues,
                client_id: _this.oAuthParams.clientId,
                prompt: 'login',
                redirect_uri: redirectUri,
                response_type: 'id_token token',
                scope: _this.oAuthParams.scope,
            }).toString();
            window.location.href = url.href;
        };
        this.params = params;
        this.oAuthParams = oAuthParams;
    }
    return OidcClient;
}());
exports.OidcClient = OidcClient;
//# sourceMappingURL=OidcClient.js.map